import { apiClient } from '@app/lib'
import { useSugarContext } from '@app/providers'
import { type SugarEditExpenditureResponse } from '@app/types'
import { useMutation, useQueryClient } from '@tanstack/react-query'

export const useLockExpenditure = () => {
  const queryClient = useQueryClient()
  const sugar = useSugarContext()

  return useMutation({
    mutationKey: ['lockExpenditure'],
    mutationFn: async (params: { schoolYearId: string; quarterId: string; providerId?: string }) => {
      const { data } = await apiClient.get<SugarEditExpenditureResponse>('/api/expenditures/lock', {
        params
      })

      return data
    },
    onSuccess: async (data) => {
      const { schoolYearId, quarterId, providerId } = data.data

      queryClient.setQueryData(
        ['expenditure', sugar?.isProviderRequired ? [schoolYearId, quarterId, providerId] : [schoolYearId, quarterId]],
        data
      )

      await queryClient.invalidateQueries({
        queryKey: ['expenditures']
      })

      return data
    }
  })
}
